export default __webpack_public_path__ + "static/media/test5.a0b07ad0.png";